// Abstract base for a Party Mode visualizer. Concrete visualizers (see
// visualizers/) extend this and are swapped in/out of a single shared
// SceneManager (scene-manager.js) - only the active visualizer's
// init()/dispose() run when switching, the WebGLRenderer itself is never
// recreated.
export class Visualizer {
  // scene: THREE.Scene, camera: THREE.PerspectiveCamera - both owned by
  // SceneManager. A visualizer adds/removes its own objects from `scene`
  // in init()/dispose() and may reposition `camera`, but doesn't own
  // either.
  init(scene, camera) {
    throw new Error('Visualizer.init() not implemented');
  }

  // deltaTime in seconds. profile is a SonosVisualProfile (see
  // sonos-visual-profile.js) - always the latest one, even on frames
  // where nothing changed.
  update(deltaTime, profile) {
    throw new Error('Visualizer.update() not implemented');
  }

  // Called once exactly when profile.trackId changes (not every poll).
  onTrackChange(profile) {}

  // Called when playbackState transitions (PLAYING/PAUSED/STOPPED).
  onPlayPause(playbackState) {}

  // Must remove everything this visualizer added to the scene and
  // dispose geometries/materials/textures it created.
  dispose() {
    throw new Error('Visualizer.dispose() not implemented');
  }

  // Returns this visualizer's StageLightRig instance, or null if it
  // doesn't use one. Lets debug tooling (see party-mode-controller.js's
  // head solo switcher) reach into whichever rig is currently live
  // without every visualizer needing to know that tooling exists.
  getLightRig() {
    return null;
  }
}
